module.exports = __webpack_public_path__ + "static/media/  (174).9ff7482f.jpg";